// The case screen's "Investigation period" line.
//
// 🔴 CALENDAR DAYS (v1.203.0). A `YYYY-MM-DD` case date is a day, not an instant: parsing it as
// UTC midnight and formatting in local time showed it a day early in every US time zone
// ("Oct 21 – Oct 25" for a case dated 10/22–10/26). Formatted at noon UTC in UTC, the same fix
// as storyGenerator's formatDateOnly. The range is inclusive of both days, so 10/22–10/26 is
// 5 days, not 4.
export function formatDateRange(start, end) {
  const day = (v) => {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(v ?? ''));
    return m ? new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], 12)) : null;
  };
  const s = day(start);
  const e = day(end);
  if (!s || !e) return `${start} – ${end}`;
  const fmt = (d, withYear) => d.toLocaleDateString('en-US', {
    timeZone: 'UTC', month: 'short', day: 'numeric', ...(withYear ? { year: 'numeric' } : {}),
  });
  const days = Math.round((e - s) / 86400000) + 1;
  return `${fmt(s, false)} – ${fmt(e, true)} (${days} day${days !== 1 ? 's' : ''})`;
}
